import { render, staticRenderFns } from "./company-reply.vue?vue&type=template&id=88cf0100&"
import script from "./company-reply.vue?vue&type=script&lang=js&"
export * from "./company-reply.vue?vue&type=script&lang=js&"
import style0 from "./company-reply.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports